import template from './template'

const createLoader = () => {
  $(template).appendTo('body')
}


export default createLoader



// WEBPACK FOOTER //
// ./app/utils/loader/createLoader.js